<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-target-number-range">
    <input v-if="type=='targetRange'" ref="targetInput" type="input" placeholder="Enter value" class="input-value" :class="{'has-error':((data.value==null||data.value=='')&&data.operator&&data.operator!='-'), 'no-value': data.value==null||data.value==''}" v-model="localData.value" @change="handleChangeTarget" @focus="handleFocus" @blur="handleBlur" @keypress="checkNumber">
    <input v-else ref="targetInput" type="input" placeholder="Enter value" class="input-value" :class="{'has-error':((data.value==null||data.value=='')&&data.operator&&data.operator!='-'), 'no-value': data.value==null||data.value==''}" v-model="data.value" @keypress="checkNumber">
  </div>
</template>

<script>

export default {
  name: 'wy-target-number-range',
  props:['controller', 'data', 'rowIndex', 'tableData', 'columnName', 'value', 'type'],
  data() {
    return {
      localData: {}
    }
  },

  watch: {
    data(value) {
      this.localData = value
    },
    localData: {
      handler: function(newValue) {
        if(this.controller.controller.isEditing) {
          if(newValue.value == '') {
            newValue.value = null;
          }
          if(newValue.value == null) {
            this.tableData[this.rowIndex][this.columnName].value = newValue.value;
          }
          else {
            this.tableData[this.rowIndex][this.columnName].value = Number(newValue.value);
          }
          // this.controller.controller.tableData.data = this.tableData;
          let keywordList = this.controller.searchKeywordInput.split(',').map(item => {
            return item.trim().replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
          });
          this.controller.controller.tableDataClone.data = this.controller.controller.originTableData.data.filter(item => new RegExp(keywordList.join("|"), 'i').test(item.name))
          if(JSON.stringify(this.tableData) == JSON.stringify(this.controller.controller.tableDataClone.data)) {
            this.controller.controller.controller.hasNoSavedChanges = false
          }
          else {
            this.controller.controller.controller.hasNoSavedChanges = true
          }
        }
      },
      deep: true
    }
  },
  

  methods: {
    handleChangeTarget() {
      this.controller.controller.isEditing = false;
      if(this.controller.controller && this.controller.controller.updatedTargetList) {
        this.controller.controller.updatedTargetList(this.tableData[this.rowIndex]) 
      }
    },

    handleFocus() {
      this.controller.controller.isEditing = true 
    },

    handleBlur() {
      // this.controller.controller.isEditing = false 
    },

    checkNumber(event) {
      let value = '';
      var keyCode = event.keyCode || event.which;
      if (keyCode >= 48 && keyCode <= 57) {
        if(this.type == 'targetRange') {
          if(this.localData.value != null) {
            value = this.localData.value + event.key
          }
          let valid = /^\d*$/.test(value); //Integer >= 0
          if(!valid) {
            event.returnValue = false
          }
        }
        else {
          if(this.data.value != null) {
            value = this.data.value + event.key
          }
          let valid = /^\d*$/.test(value); //Integer >= 0
          if(!valid) {
            event.returnValue = false
          }
        }
      }
      else {
        event.preventDefault()
        return false;
      }
    }
  },
  created() {
    this.localData = this.data//JSON.parse(JSON.stringify(this.data));
  }
}
</script>

<style lang="scss">
.wy-target-number-range {
  margin-left: unset;
  .input-value {
    height: 30px;
    width: 70px;
    border: 1px #106FBC solid;
    border-radius: 5px;
    text-align: center;
    background-color: #E8F1FF;
    outline: none;
  }
  .input-value.no-value {
    background-color: #FFF;
    border: 1px #CAD2DA solid;
  }
  .input-value:focus {
    background-color:#FFF;
    border: 1px #106FBC solid;
  }
  .input-value.has-error {
    background-color: #FFF4F4;
    border: 1px #EBAFBA solid;
  }
  .seperator {
    padding: 0px 5px;
    line-height: 2.5;
    color: #CAD2DA;
  }
  .with-error {
    background-color: #FFF4F4;
    border-color: #EBAFBA;
  }
}
</style>
